import React, { useState } from "react";
import { BoxButton, CDialog, Icon } from "shared";
import { Send } from "assets";
import { useTranslation } from "react-i18next";
import { InviteProviderPatientForm } from "./InviteProviderPatientForm";

export const InviteProviderPatient: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return (
    <>
      <BoxButton startIcon={<Icon of={Send} />} onClick={openDialog}>
        {t("form.invite_provider_patient")}
      </BoxButton>

      <CDialog maxWidth="xs" fullWidth open={isOpen} onClose={closeDialog} aria-labelledby="invite-provider-patient">
        <InviteProviderPatientForm onClose={closeDialog} />
      </CDialog>
    </>
  );
};
